import React from "react";

export default function BioPopup({ popup }) {
  if (!popup) return null;

  const typeClass =
    popup.type === "success"
      ? "border-green-300 text-green-700"
      : popup.type === "error"
      ? "border-red-300 text-red-700"
      : "border-pink-200 text-pink-700";

  return (
    <div
      className={`text-xs sm:text-sm px-4 py-2 rounded-xl shadow-md border bg-white/95 flex gap-2 ${typeClass}`}
    >
      <span>{popup.type === "success" ? "✅" : popup.type === "error" ? "⚠️" : "💡"}</span>
      <span dangerouslySetInnerHTML={{ __html: popup.message }} />
    </div>
  );
}
